export default {
  courses: 'Kurse',
  myCourses: 'Meine Kurse',
  register: 'Registrieren',
  profile: 'Profil',
  login: 'Einloggen',
  logout: 'Ausloggen'
}
